import { FaGithub } from "react-icons/fa";
import { BiLinkExternal } from "react-icons/bi";
import { medistore, pdfTools, portfolio } from "../../assets/index";

const BeginerProject = () => {
  const projectList = [
    {
      img: medistore,
      title: "The Medical helper - Medistore",
      techstack:
        "Reactjs,TailwindCSS, Nodejs, ExpressJs, MongoDb,  #Frontend   #Backend      #Web based application || $Filtering menu",
      live: "https://medical-data-management-system.vercel.app/",
      github: "https://github.com/Sastik/medical-data-management-system",
    },
    {
      img: pdfTools,
      title: "PDF tools",
      techstack:
        "Tailwind-CSS JavaScript Reactjs #Frontend  #Web based application || $API integration $PDF merger $JPG to PDF converter $PDf split",
      live: "https://pdf-handelers.netlify.app/",
      github: "https://github.com/Sastik/pdf_tools",
    },
    {
      img: portfolio,
      title: "Portfolio Website",
      techstack: "HTML, CSS, JavaScript #Frontend  #Web based application",
      live: "https://sample-portfolio-sastik.netlify.app/",
      github: "https://github.com/Sastik/Personal-Portfolio-website",
    },
    
  ];

  return (
    <div className="flex flex-wrap justify-center gap-10">
      {projectList.map(({ img, live, github, title, techstack }, index) => (
        <div
          key={index}
          className="flex flex-col w-96 gap-2 bg-gray-50 drop-shadow-xl dark:bg-grey-800 rounded-lg p-4"
        >
          <div className="relative group rounded-lg bg-violet-50">
            <img
              alt={`Project: ${title}`}
              width={1000}
              height={1000}
              className="max-w-full h-48 max-h-full object-cover object-top rounded-lg"
              src={img}
              loading="lazy"
            />
            <div className="absolute top-0 scale-x-0 group-hover:scale-100 transition-transform origin-top duration-200 ease-linear bg-gray-800 bg-opacity-60 w-full h-full rounded-lg flex items-center gap-4 justify-center">
              <a
                href={live}
                className="bg-white text-black p-2 rounded-lg hover:bg-black hover:text-white transition-all"
              >
                <BiLinkExternal className="animate-pulse" size={20} />
              </a>
              <a
                href={github}
                className="bg-white text-black p-2 rounded-lg hover:bg-black hover:text-white transition-all"
              >
                <FaGithub className="animate-bounce" size={20} />
              </a>
            </div>
          </div>
          <div className="my-2 flex flex-col gap-3">
            <h3 className="text-xl text-center text-black font-medium">
              {title}
            </h3>
            <p className="text-sm font-semibold text-gray-600">
              <span className="font-medium">Tech Stack: </span>
              {techstack}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BeginerProject;
